<template>
  <div class="pa-4">
    <RichText
      v-model="store.plan.action_register"
      label="8.1 Action Register"
      class="mb-4"
      required
      :readonly="readonly"
    />
  </div>
</template>

<script setup lang="ts">
import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";

const props = defineProps<{
  readonly: boolean;
}>();

const store = useAMPStore();
</script>
